<template>
    <DropdownMenuPortal><slot /></DropdownMenuPortal>
</template>
<script setup lang="ts">
import { DropdownMenuPortal } from "reka-ui";
</script>
